import { Action, ActionType } from "models/verifyResetPasswordToken";
import createReducer from "redux/createReducer";

export interface VerifyResetPasswordTokenReducerType {
  loading: boolean;
  error?: string;
  verifyResetPasswordTokenResponse?: any;
}

const defaultState: VerifyResetPasswordTokenReducerType = {
  loading: false,
  error: undefined,
  verifyResetPasswordTokenResponse: undefined,
};

export const verifyResetPasswordTokenReducer =
  createReducer<VerifyResetPasswordTokenReducerType>(defaultState, {
    [ActionType.VERIFY_RESET_TOKEN](
      state: VerifyResetPasswordTokenReducerType
    ) {
      return {
        ...state,
        loading: true,
      };
    },

    [ActionType.VERIFY_RESET_TOKEN_ERROR](
      state: VerifyResetPasswordTokenReducerType,
      action: Action<any>
    ) {
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    },

    [ActionType.VERIFY_RESET_TOKEN_SUCCESS](
      state: VerifyResetPasswordTokenReducerType,
      action: Action<any>
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        verifyResetPasswordTokenResponse: action.payload,
      };
    },

    [ActionType.RESET_VERIFY_RESET_TOKEN](
      state: VerifyResetPasswordTokenReducerType
    ) {
      return {
        ...state,
        loading: false,
        error: null,
        verifyResetPasswordTokenResponse: undefined,
      };
    },
  });
